{
    "CmeList_Column_ID": "IDENTIFIANT",
    "CmeList_Column_Description": "Description",
    "CmeList_Column_ChildCMEs": "CME",
    "CmeList_Column_TelSyss": "Serveurs de téléphonie",
    "CmeList_Column_Partitions": "Cloisons",
    "CmeList_Column_Users": "Utilisateurs",
    "CmeList_CountLink_TelSyssAria": "Serveurs de téléphonie ouverts filtrés vers cet environnement CM",
    "CmeList_CountLink_PartitionsAria": "Codes ouverts filtrés pour cet environnement CM",
    "CmeList_CountLink_UsersAria": "Utilisateurs de l'application ouverte filtrés vers cet environnement CM",
    "NAME": "CmeListLanguage"
}